import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';

// Pages
import Home from './pages/Home';
import Library from './pages/Library';
import ResourceDetail from './pages/ResourceDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import Donate from './pages/Donate';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import DailyWord from './pages/DailyWord';
import FaithTeachings from './pages/FaithTeachings';
import Videos from './pages/Videos';
import Books from './pages/Books';
import GenZSeries from './pages/GenZSeries';
import GenZLesson from './pages/GenZLesson';
import FeaturedVideo from './pages/FeaturedVideo';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/books" element={<Books />} />
              <Route path="/gen-z" element={<GenZSeries />} />
              <Route path="/gen-z/:slug" element={<GenZLesson />} />
              <Route path="/videos" element={<Videos />} />
              <Route path="/videos/featured/:slug" element={<FeaturedVideo />} />
              <Route path="/daily-word" element={<DailyWord />} />
              <Route path="/faith-teachings" element={<FaithTeachings />} />
              <Route path="/library/:type" element={<Library />} />
              <Route path="/resource/:id" element={<ResourceDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/donate" element={<Donate />} />
              <Route path="/donate/success" element={<Donate />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
